export type PlanId = 'basic' | 'pro' | 'max';

export interface Entitlements {
	maxChildren: number;
	maxObservers: number;
	canAddEvents: boolean;
	/**
	 * Dla Basic: zamiast dni obowiązuje limit ostatnich wpisów (mini historia)
	 * Jeśli historyDays === 0 i set miniHistoryCount > 0, używamy mini historii.
	 */
	historyDays: number;
	miniHistoryCount?: number;
	/**
	 * Docelowa flaga sterująca reklamami; na razie nieużywana w UI.
	 */
	adsDisabled: boolean;
	reportsEnabled: boolean;
	recentChangesEnabled: boolean;
}

export const PLANS: Record<PlanId, Entitlements> = {
	basic: {
		maxChildren: 1,
		maxObservers: 0,
		canAddEvents: false,
		historyDays: 0,
		miniHistoryCount: 10,
		adsDisabled: false,
		reportsEnabled: false,
		recentChangesEnabled: false
	},
	pro: {
		maxChildren: 2,
		maxObservers: 1,
		canAddEvents: true,
		historyDays: 180,
		adsDisabled: true,
		reportsEnabled: false,
		recentChangesEnabled: true
	},
	max: {
		maxChildren: 5,
		maxObservers: 3,
		canAddEvents: true,
		historyDays: 180,
		adsDisabled: true,
		reportsEnabled: true,
		recentChangesEnabled: true
	}
};

export function isValidPlanId(planId: string): planId is PlanId {
	return planId === 'basic' || planId === 'pro' || planId === 'max';
}


